import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Terms extends Component {
	render() {
		return (
			<>
				<div className="page-content bg-white">
					<div className="banner-wraper">
						<div className="page-banner" style={{ backgroundColor: '#f4f4f4', padding: '50px 0' }}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Terms of Service</h1>
									<p className="mb-0">Terms that govern your use of this website and our communications.</p>
								</div>
							</div>
						</div>
					</div>

					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-12">
									<p><strong>Last Updated:</strong> July 1st, 2026</p>
									<p>This website is operated by Family EcoDental, LLC, doing business as Family Eco Dental.</p>

									<h3>Agreement to Terms</h3>
									<p>
										By accessing or using this website, you agree to these Terms of Service to the extent permitted by applicable law.
										If you do not agree with these terms, please do not use this website.
									</p>

									<h3>Medical Disclaimer</h3>
									<p>
										Website content is provided for general informational purposes only and is not medical or dental advice.
										Use of this website does not create a provider-patient relationship. For diagnosis and treatment, please
										schedule an appointment with a licensed dental professional.
									</p>

									<h3>Appointments and Communications</h3>
									<p>
										Appointment requests submitted through this website are not guaranteed until confirmed by our office.
										You agree to provide accurate contact information so we can communicate with you about scheduling,
										care coordination, and related office updates.
									</p>

									<h3>SMS Text Messaging Program</h3>
									<p>We offer an SMS text messaging program for appointment reminders and care coordination. By providing your mobile phone number and opting in:</p>
									<ul>
										<li>You expressly consent to receive text messages at the number provided</li>
										<li>You confirm that you are the owner or authorized user of the mobile phone number</li>
										<li>You understand that consent is not required as a condition of receiving healthcare services</li>
										<li>Message and data rates may apply as determined by your mobile carrier</li>
									</ul>
									<p><strong>Message Types.</strong> Appointment reminders, treatment follow-ups, care updates, and care instructions for our dental patients.</p>
									<p><strong>Frequency.</strong> Typically up to 4 messages per month. During active treatment periods, you may receive additional messages.</p>
									<p><strong>Opt-Out Instructions.</strong> You can opt out at any time by:</p>
									<ul>
										<li>Replying <strong>STOP</strong> to any message you receive from us</li>
										<li>Calling our office at 201-330-2837</li>
										<li>Emailing us at team@familyecodental.com</li>
										<li>Informing our staff during your next visit</li>
									</ul>
									<p><strong>Help and Support.</strong> For help, reply <strong>HELP</strong> to any message or call our office at 201-330-2837. You can also email us at team@familyecodental.com for customer support.</p>
									<p><strong>Privacy.</strong> For details on how we handle your information, see our <Link to="/policy">Privacy Policy</Link>.</p>
									<p><strong>Limitations.</strong> SMS messages should not be used for urgent medical needs or emergencies. Message delivery is not guaranteed and may be delayed. Carriers are not liable for any delayed or undelivered messages.</p>

									<h3>Acceptable Use</h3>
									<p>You agree not to use this website in a way that:</p>
									<ul>
										<li>Violates applicable laws, regulations, or professional standards.</li>
										<li>Interferes with website security, stability, or availability.</li>
										<li>Attempts unauthorized access to systems, data, or accounts.</li>
										<li>Submits false, misleading, or fraudulent information.</li>
									</ul>

									<h3>Intellectual Property</h3>
									<p>
										Website text, graphics, logos, branding, and design are protected under applicable intellectual property laws.
										You may view website content for personal, non-commercial use only.
									</p>

									<h3>Third-Party Content and Links</h3>
									<p>
										This website may include third-party links or resources for convenience. Third-party sites are subject
										to their own terms and policies.
									</p>

									<h3>Disclaimer of Warranties</h3>
									<p>
										This website is provided on an "as is" and "as available" basis without warranties of any kind,
										either express or implied, to the fullest extent permitted by law.
									</p>

									<h3>Limitation of Liability</h3>
									<p>
										To the extent permitted by applicable law, liability related to website use, communication delays,
										or service interruptions is limited.
									</p>

									<h3>Responsibility for Use</h3>
									<p>
										You are responsible for your use of this website and for complying with these terms and applicable law.
									</p>

									<h3>Dispute Resolution and Governing Law</h3>
									<p>
										These Terms are interpreted and enforced in accordance with applicable law.
										Any dispute process and venue will be determined by applicable legal requirements.
									</p>

									<h3>Termination</h3>
									<p>
										We may suspend or terminate access to this website at any time for security, maintenance, legal,
										or misuse-related reasons.
									</p>

									<h3>Changes to These Terms</h3>
									<p>
										We may revise these Terms from time to time. Updated terms are effective upon posting. The Last Updated
										date above reflects the current version.
									</p>

									<h3>Contact Information</h3>
									<p>If you have questions about these Terms of Service, contact us at:</p>
									<ul>
										<li>Phone: 201-330-2837</li>
										<li>Email: team@familyecodental.com</li>
										<li>Mail: 407 39th Street, Suite 401, Union City, NJ 07087</li>
									</ul>
									<p>
										For details about data handling practices, please review our <Link to="/policy">Privacy Policy</Link>.
									</p>
								</div>
							</div>
						</div>
					</section>
				</div>
			</>
		);
	}
}

export default Terms;
